import { Logo } from "../components/ui";

// Grabadora del A10 (julio, B10.1): subía el audio del mostrador a la nube. APAGADA el 17-oct-2026 (Kevin:
// «Apagarlo y borrar lo viejo»; el servidor responde 410 a cualquier audio). El oído ahora vive en la compu de
// la botica (cadena huayruro-ojo-oido-agentes, tramo 09): el celular abre la página que sirve LA COMPU por
// Tailscale (https://<compu>.<tailnet>.ts.net), la compu transcribe ahí mismo y a la nube suben solo resultados.
// Esta pantalla queda para que un celular que todavía abra la dirección vieja sepa a dónde ir.
export function Grabadora() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-5 bg-app p-6 text-center text-ink">
      <Logo size={40} />
      <h1 className="text-[20px] font-bold text-ink">La grabadora se mudó a la compu</h1>
      <p className="max-w-md text-[14px] leading-relaxed text-ink-2">
        Desde el 17 de octubre el audio del mostrador ya no se sube a internet. El celular le pasa el audio a la compu de la botica, la
        compu lo convierte en texto y lo borra a las 24 horas. Solo suben los faltantes y las ventas que se oyeron.
      </p>
      <p className="max-w-md rounded-[12px] border border-line bg-card px-4 py-3 text-[13px] text-ink">
        En este celular abre la dirección de la compu de la botica (empieza con <span className="font-mono">https://</span> y termina en{" "}
        <span className="font-mono">.ts.net</span>). La tiene guardada el encargado.
      </p>
      <p className="max-w-md text-[12px] text-ink-3">Asistente de mostrador. Solo asistencia operativa; nunca vigilancia de personal.</p>
    </main>
  );
}
